import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import ScrollReveal from "@/components/motion/ScrollReveal";
import {
    HACKATHON_EVENTS_EMAIL,
    HACKATHON_FAQ,
    LUMA_REGISTRATION_URL,
    SPONSOR_CONTACT_EMAIL,
} from "@/data/agenticHackathon";

function FaqAnswer({ item }) {
    if (item.eventsEmail) {
        return (
            <>
                Email us at{" "}
                <a
                    href={`mailto:${HACKATHON_EVENTS_EMAIL}`}
                    className="text-[#E54D2E] font-medium hover:underline"
                >
                    {HACKATHON_EVENTS_EMAIL}
                </a>
            </>
        );
    }

    if (item.mentorSignup) {
        return (
            <>
                <a
                    href={LUMA_REGISTRATION_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#E54D2E] font-medium hover:underline"
                >
                    Register on Luma
                </a>{" "}
                or email{" "}
                <a
                    href={`mailto:${SPONSOR_CONTACT_EMAIL}`}
                    className="text-[#E54D2E] font-medium hover:underline"
                >
                    {SPONSOR_CONTACT_EMAIL}
                </a>{" "}
                — we will match you to a role.
            </>
        );
    }

    if (item.a.includes("chidi@cheppar.co.ke")) {
        const [before, after] = item.a.split("chidi@cheppar.co.ke");
        return (
            <>
                {before}
                <a
                    href={`mailto:${SPONSOR_CONTACT_EMAIL}`}
                    className="text-[#E54D2E] font-medium hover:underline"
                >
                    {SPONSOR_CONTACT_EMAIL}
                </a>
                {after}
            </>
        );
    }

    return item.a;
}

export default function HackathonFAQ() {
    return (
        <section
            id="faq"
            data-testid="hackathon-faq"
            className="py-14 sm:py-20 md:py-28 bg-white border-t border-black/[0.06]"
        >
            <div className="mx-auto max-w-[1100px] px-4 sm:px-6 md:px-10 lg:px-16">
                <ScrollReveal className="mb-10 sm:mb-14 max-w-2xl">
                    <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-5">
                        <span className="h-px w-8 bg-zinc-400" />
                        FAQ
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-[-0.03em] text-zinc-950 leading-[0.95]">
                        Before you register.
                    </h2>
                    <p className="mt-5 text-zinc-600 leading-relaxed">
                        Everything you need to know about Agentic Hack in
                        Nakuru.
                    </p>
                </ScrollReveal>

                <ScrollReveal delay={0.08}>
                    <Accordion
                        type="single"
                        collapsible
                        defaultValue="item-0"
                        className="w-full"
                    >
                        {HACKATHON_FAQ.map((item, i) => (
                            <AccordionItem
                                key={item.q}
                                value={`item-${i}`}
                                data-testid={`hackathon-faq-${i}`}
                                className="border-b border-black/10"
                            >
                                <AccordionTrigger className="py-5 sm:py-6 text-left font-display text-lg sm:text-xl md:text-2xl font-semibold tracking-tight text-zinc-950 hover:no-underline">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 sm:pb-6 text-base text-zinc-600 leading-relaxed">
                                    <FaqAnswer item={item} />
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </ScrollReveal>
            </div>
        </section>
    );
}
